import {
  DSCardWrapper,
  DSCircularButton,
  DSInput,
} from "@components/design-system/molecules";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import React from "react";

import { EXTENSION_CONSTRAINTS } from "./extensionUtils";

const Step = ({ stepNumber, type, value, onChange, onRemove }) => {
  const isWaitStep = type === "wait";
  const label = isWaitStep ? "Wait:" : "Press:";

  const handleChange = (e) => {
    if (isWaitStep) {
      const raw = e.target.value;
      if (raw === "") {
        onChange("");
        return;
      }
      const parsed = parseInt(raw) || 0;
      const min = Math.min(
        parsed,
        EXTENSION_CONSTRAINTS.MAX_WAIT_SECONDS,
      );
      onChange(min);
    } else {
      onChange(e.target.value);
    }
  };

  return (
    <DSCardWrapper variant="default" padding="p-sm">
      <div className="flex flex-row items-center space-x-3">
        <span className="text-sm font-medium text-primary w-6">
          {stepNumber}.
        </span>
        <span className="text-sm text-secondary">{label}</span>
        <div className="flex flex-row items-center w-24">
          <DSInput
            type={isWaitStep ? "number" : "text"}
            value={isWaitStep && value === "" ? "" : value}
            onChange={handleChange}
            placeholder={isWaitStep ? undefined : "0"}
            min={
              isWaitStep
                ? EXTENSION_CONSTRAINTS.MIN_WAIT_SECONDS
                : undefined
            }
            max={
              isWaitStep
                ? EXTENSION_CONSTRAINTS.MAX_WAIT_SECONDS
                : undefined
            }
            step={isWaitStep ? "1" : undefined}
            dataTestId="extension-step-input"
            size="sm"
          />
        </div>
        {isWaitStep && (
          <span className="text-sm text-secondary">sec</span>
        )}
        <DSCircularButton
          icon={faTrash}
          onClick={onRemove}
          variant="danger"
          size="sm"
          title="Remove step"
          dataTestId="extension-step-delete-button"
        />
      </div>
    </DSCardWrapper>
  );
};

export default Step;
